import { FC } from 'react'
import cn from 'classnames'
import LoadingImg from '../images/loading.svg'
interface LoadingProps {
  className?: string
}

export const Loading: FC<LoadingProps> = ({ className }) => (
  <div className={cn('loading-content', className)}>
    <img src={LoadingImg} alt="" />
  </div>
)
